import React from "react";
import PageHeader from "../../components/PageHeader";
import VehicleListComponent from "../../components/Vehicle/VehicleList";

class VehicleList extends React.Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}
            >
                <div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="Vehicles"
                            Breadcrumb={[
                                { name: "Vehicles", navigate: "" },
                            ]}
                        />
                        <div className="row clearfix">
                            <VehicleListComponent />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default VehicleList;
